export default __webpack_public_path__ + "static/media/f_slideshow.96ac21b0.svg";